'use client';

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from '@svs/ui/react/select';
import type { ReactNode } from 'react';

type CouponAdditionsCommissionSelectorProps = {
  commissionValueOptions: number[];
  onValueChange: (value: number) => void;
  selectedCommissionPercent: number;
  commissionPercent: number;
};

/**
 * Component responsible for rendering the commission selector in the coupon additions.
 *
 * @param root0 props
 * @param root0.commissionValueOptions list of commission value options
 * @param root0.onValueChange callback for when the selected commission changes
 * @param root0.selectedCommissionPercent the currently selected commission percentage
 * @param root0.commissionPercent the commission percent for the activated draw, used to determine if some options should be disabled
 * @returns renders the commission selector
 */
export function CouponAdditionsCommissionSelector({
  commissionValueOptions,
  onValueChange,
  selectedCommissionPercent,
  commissionPercent,
}: CouponAdditionsCommissionSelectorProps): ReactNode {
  const selectedValue = `${selectedCommissionPercent}`;

  return (
    <Select
      value={selectedValue}
      onValueChange={(value: string) => {
        onValueChange(Number.parseInt(value, 10));
      }}
    >
      <SelectTrigger className="w-full" aria-invalid={false}>
        <SelectValue placeholder="Välj avgift" />
      </SelectTrigger>
      <SelectContent className="z-60">
        <SelectGroup>
          <SelectLabel>Spelpott</SelectLabel>
          {commissionValueOptions.map((commissionValue, index) => {
            return (
              // eslint-disable-next-line react/no-array-index-key
              <SelectItem key={`commission-${index}`} value={`${index}`} disabled={index > commissionPercent}>
                {index}% (Spelpott: {commissionValue} kr)
              </SelectItem>
            );
          })}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
